import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import AppContext from '../context/Context';

function SettingsToggle() {
  const { setConfig } = useContext(AppContext);

  const handleClick = () => {
    setConfig('showSettingPanel', true);
  };

  return (
    <Button
      variant="link"
      className="rounded-circle px-2 py-1 bg-light "
        // className="setting-toggle"
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={faGear} />
    </Button>
  );
}

export default SettingsToggle;
